export default {"src":"/_next/static/media/favicon-codeai.939c3738.ico","height":32,"width":32,"blurWidth":0,"blurHeight":0};